import React from 'react';

import ForgotPage from '@/features/login/pages/forgot.page';

const LoginRoute = () => {
  return <ForgotPage />;
};

export default LoginRoute;
